import React from 'react'
import { useLocation, Link } from 'react-router-dom'
import styles from './Layout.module.css'

const Layout = ({ children, title, route }) => {

    const location = useLocation()
    return (
        <div className={styles.container}>
            <div className={styles.box}></div>
            <header className={styles.header}>
                <Link to={route}>
                    <i className={styles.backIcon + " fas fa-chevron-left"}></i>
                </Link>
                <h1>{title}</h1>
            </header>
            <nav className={styles.nav}>
                <i
                    className={location.pathname === '/pickup-location' ? styles.selectedIcon + " fas fa-map-marker-alt" : styles.unselectedIcon + " fas fa-map-marker-alt"}
                ></i>
                <i className={location.pathname === '/drop-location' ? styles.selectedIcon + " fas fa-location-arrow" : styles.unselectedIcon + " fas fa-location-arrow"}></i>
                <i className={location.pathname === '/courier-info' ? styles.selectedIcon + " fas fa-truck" : styles.unselectedIcon + " fas fa-truck"}></i>
                <i className={location.pathname === '/confirm-info' ? styles.selectedIcon + " fas fa-file-alt" : styles.unselectedIcon + " fas fa-file-alt"}></i>
            </nav>
            { children}
        </div>
    )
}

export default Layout
